module.exports = __webpack_public_path__ + "img/picture.8c3430fa.png";